exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".invited-user-icon-wrapper-3e527k2ymwr{background-color:#E7963B;border-radius:50%}.invited-user-icon-wrapper-3e527k2ymwr svg path{fill:var(--always-light-text)}@media screen and (-ms-high-contrast: active){.invited-user-icon-wrapper-3e527k2ymwr{background-color:transparent}.invited-user-icon-wrapper-3e527k2ymwr svg path{fill:buttonText}}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"wrapper": "invited-user-icon-wrapper-3e527k2ymwr"
};